import { Input } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { SearchOutlined } from '@ant-design/icons'
import styles from './IntegrationPurchaseFilter.module.scss'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { getIntegrationPurchasesFiltered } from 'src/core/helpers'
import { integrationPurchasesSelector, setIntegrationPurchasesFiltered } from 'src/features'

const IntegrationPurchaseFilter: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [filterText, setFilterText] = useState<string>(null)
  const { data } = useAppSelector(integrationPurchasesSelector)

  return <Input
    allowClear
    value={filterText}
    placeholder={t('Withdrawals.Filter')}
    prefix={<SearchOutlined />}
    className={styles.input}
    onChange={(e) => {
      const text = e.target.value
      const newList = getIntegrationPurchasesFiltered(text, data)
      dispatch(setIntegrationPurchasesFiltered(newList))
      setFilterText(text)
    }}
  />
}

export default IntegrationPurchaseFilter
